import { render } from "./BackgroundImage.vue?vue&type=template&id=5ea4fbcf&scoped=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=js"
export * from "./BackgroundImage.vue?vue&type=script&lang=js"

import "./BackgroundImage.vue?vue&type=style&index=0&id=5ea4fbcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea4fbcf"]])

export default __exports__